/* tslint:disable */

declare var Object: any;
export interface ViewGoEmpInterface {
  "userId": number;
  "firstName"?: string;
  "lastName"?: string;
  "userName": string;
  "middleName"?: string;
  "fullName"?: string;
  "empId"?: string;
  "empNo"?: string;
  "positionId"?: number;
  "email"?: string;
  "posCode"?: string;
  "posNameEn"?: string;
  "companyId"?: number;
  "spvParent"?: string;
  "spvPath"?: string;
  "startDate"?: Date;
  "endDate"?: Date;
  "photo"?: string;
  "address"?: string;
  "phone"?: string;
  view_path?: any;
}

export class ViewGoEmp implements ViewGoEmpInterface {
  "userId": number;
  "firstName": string;
  "lastName": string;
  "userName": string;
  "middleName": string;
  "fullName": string;
  "empId": string;
  "empNo": string;
  "positionId": number;
  "email": string;
  "posCode": string;
  "posNameEn": string;
  "companyId": number;
  "spvParent": string;
  "spvPath": string;
  "startDate": Date;
  "endDate": Date;
  "photo": string;
  "address": string;
  "phone": string;
  view_path: any;
  constructor(data?: ViewGoEmpInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewGoEmp`.
   */
  public static getModelName() {
    return "ViewGoEmp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewGoEmp for dynamic purposes.
  **/
  public static factory(data: ViewGoEmpInterface): ViewGoEmp{
    return new ViewGoEmp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewGoEmp',
      plural: 'ViewGoEmps',
      path: 'ViewGoEmps',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "userName": {
          name: 'userName',
          type: 'string'
        },
        "middleName": {
          name: 'middleName',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "empNo": {
          name: 'empNo',
          type: 'string'
        },
        "positionId": {
          name: 'positionId',
          type: 'number'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "posCode": {
          name: 'posCode',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "spvParent": {
          name: 'spvParent',
          type: 'string'
        },
        "spvPath": {
          name: 'spvPath',
          type: 'string'
        },
        "startDate": {
          name: 'startDate',
          type: 'Date'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "photo": {
          name: 'photo',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
      },
      relations: {
        view_path: {
          name: 'view_path',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewGoEmp.ts